import { useRef, useState } from "react";
import { Upload, X } from "lucide-react";
import { fileToB64 } from "../lib/api";

export function UploadZone({ value, onChange, label = "Upload image", testId = "upload-zone" }) {
  const inputRef = useRef();
  const [dragging, setDragging] = useState(false);

  const handleFile = async (file) => {
    if (!file || !file.type.startsWith("image/")) return;
    onChange(await fileToB64(file));
  };

  return (
    <div>
      {value ? (
        <div className="relative border border-zinc-200 rounded-md overflow-hidden bg-white">
          <img src={value} alt="Uploaded" className="w-full h-56 object-contain bg-zinc-50" />
          <button data-testid={`${testId}-clear`} onClick={() => onChange(null)}
            className="absolute top-2 right-2 bg-white border border-zinc-200 rounded-full p-1.5 hover:bg-zinc-100">
            <X size={14} />
          </button>
        </div>
      ) : (
        <div data-testid={testId}
          onClick={() => inputRef.current?.click()}
          onDragOver={(e) => { e.preventDefault(); setDragging(true); }}
          onDragLeave={() => setDragging(false)}
          onDrop={(e) => { e.preventDefault(); setDragging(false); handleFile(e.dataTransfer.files?.[0]); }}
          className={`border-2 border-dashed rounded-md h-56 flex flex-col items-center justify-center cursor-pointer transition-colors bg-white ${
            dragging ? "border-zinc-950 bg-zinc-50" : "border-zinc-300 hover:border-zinc-400"
          }`}>
          <Upload size={22} className="text-zinc-400 mb-3" />
          <p className="text-sm font-medium">{label}</p>
          <p className="text-xs text-zinc-400 mt-1">Click or drag & drop — PNG, JPG</p>
        </div>
      )}
      <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={(e) => handleFile(e.target.files?.[0])} />
    </div>
  );
}
